"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.upload.choose': 'Wybierz plik...',
    'file.upload.change': 'Zmień plik',
    'file.upload.remove': 'Usuń plik',
    'file.upload.loading': 'Ładowanie...',
    'file.upload.drop': 'Upuść plik tutaj',
    'file.upload.download': 'Pobierz plik',
    'file.upload.choose_multiple': 'Wybierz pliki...',
    'file.upload.change_multiple': 'Zmień pliki',
    'file.upload.remove_all': 'Usuń wszystkie pliki',
    'file.upload.error.size_too_large': 'Plik "{fileName}" jest zbyt duży. Maksymalny rozmiar pliku to 2MB.',
    'file.upload.error.size_exceeded_10mb': 'Plik "{fileName}" jest zbyt duży. Maksymalny rozmiar pliku to {maxSize}.',
    'file.upload.error.multiple_files_size_exceeded_10mb': 'Następujące pliki są zbyt duże: {fileNames}. Maksymalny rozmiar pliku to {maxSize}.',
    'file.upload.error.image_too_large': 'Obraz "{filename}" ({size}) jest zbyt duży. Obrazy muszą być mniejsze niż {maxSize}.',
    'file.upload.error.unsupported_type': 'Nieobsługiwany typ pliku. Proszę wybrać obsługiwany format pliku.',
    'file.upload.confirm.add_to_knowledge': 'Plik "{fileName}" ({fileSize}) jest zbyt duży dla czatu. Czy chciałbyś dodać go do bazy wiedzy zamiast tego?',
    'file.upload.error.total_size_exceeded': 'Dodanie tego pliku przekroczyłoby limit całkowity 5MB. Aktualny całkowity: {currentSize}, próba dodania: {newSize}.',
    'file.upload.error.processing_failed': 'Błąd przetwarzania pliku "{fileName}": {error}',
    'file.upload.error.upload_failed': 'Błąd przesyłania plików: {error}',
    'file.upload.error.submission_failed': 'Błąd podczas wysyłania czatu: {error}',
};
